export const GOOGLE_SHEET_URL = "https://script.google.com/macros/s/AKfycbxdPbiFc4XXCLAVB_ge6Wrzke37pWfZRN4-IWbkerM6DPnYSKlng8eAc9IsvpU2zY-IdA/exec";
